import { render, staticRenderFns } from "./edit-bank.vue?vue&type=template&id=47a8c5e0&"
import script from "./edit-bank.vue?vue&type=script&lang=js&"
export * from "./edit-bank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports